'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getRef = require('./getRef');

var _getRef2 = _interopRequireDefault(_getRef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createRef || function createRef() {
  function ref(instanceOrNode) {
    ref.current = (0, _getRef2.default)(instanceOrNode) || null;
  }

  ref.current = null;

  if (process.env.NODE_ENV !== 'production') {
    Object.seal(ref);
  }

  return ref;
};

module.exports = exports['default'];